<template>
    <div class="text-center pa-4">
      <v-dialog
        v-model="deleteDialog"
        width="auto"
      >
        <v-card
          max-width="400"
          prepend-icon="$error"
          text="Vous voulez vraiment supprimer l'article?"
          title="Suppression"
        >
          <template v-slot:actions>

            <v-card-actions>
                <v-btn
                    text="Annuler"
                    @click="deleteDialog = false"
                    variant="plain"
                    color="green"
                ></v-btn>
                <v-btn
                    color="red"
                    text="Supprimer"
                    @click="supprimer();deleteDialog = false"
                    variant="plain"
                ></v-btn>
            </v-card-actions>  
          </template>
        </v-card>
      </v-dialog>
    </div>
  </template>
<script setup>
import store from './store';
const props=defineProps({
    itemtoDelete:Object
})
let deleteDialog=defineModel()
const supprimer=()=>{
        store.commit('deleteRowArticle',props.itemtoDelete)
    }
</script>